import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { Button, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FeatureCard } from '@/components/FeatureCard';
import type { PublicCatalogSupport } from '@/features/operations/api';
import { FeaturedDevicesSlot } from './FeaturedDevicesSlot';
import { HomeSection } from './HomeSection';

type UsedDevicesSectionProps = {
  warranty: PublicCatalogSupport['warranty'];
};

/** What PhoneTec publishes, why it can be trusted, and the way into the catalogue. */
export function UsedDevicesSection({ warranty }: UsedDevicesSectionProps) {
  // The warranty is whatever an ADMIN configured (BR-024); without it the card still speaks
  // about the backing, without promising a duration.
  const backingDescription = warranty
    ? `Cada equipo vendido lleva la garantía PhoneTec de ${warranty.durationMonths} ${
        warranty.durationMonths === 1 ? 'mes' : 'meses'
      }.`
    : 'PhoneTec responde por cada equipo que publica.';

  const highlights = [
    {
      title: 'Revisados por técnicos',
      description: 'Cada equipo se inspecciona en PhoneTec antes de publicarse.',
      icon: <FactCheckOutlinedIcon color="secondary" />,
    },
    {
      title: 'Solo equipos certificados',
      description: 'Publicamos únicamente los equipos que PhoneTec aprobó y certificó.',
      icon: <VerifiedOutlinedIcon color="secondary" />,
    },
    {
      title: 'Respaldo PhoneTec',
      description: backingDescription,
      icon: <SecurityOutlinedIcon color="secondary" />,
    },
  ];

  return (
    <HomeSection
      id="used-devices"
      eyebrow="USADOS CERTIFICADOS"
      title="No es un marketplace."
      description="No comprás a un desconocido: cada celular del catálogo pasó por PhoneTec, que lo revisó, lo aprobó y responde por él."
    >
      <Grid container spacing={3}>
        {highlights.map((item) => (
          <Grid item xs={12} md={4} key={item.title}>
            <FeatureCard title={item.title} description={item.description} icon={item.icon} />
          </Grid>
        ))}
      </Grid>
      <FeaturedDevicesSlot />
      <Button
        component={RouterLink}
        to="/catalog"
        variant="outlined"
        color="inherit"
        endIcon={<ArrowForwardIcon />}
        sx={{ alignSelf: 'flex-start' }}
      >
        Ver equipos
      </Button>
    </HomeSection>
  );
}
